import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartLine, faPlus, faSortDown, faSortUp} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import {useTranslation} from "react-i18next";
import {Consts} from "../pages/consts";
import {useContext} from "react";
import InitContext from "../pages/InitContext";

const SortAndAddNewTest = ({
  labTests,
  handleSortChange,
  setAddLabTest,
  sortConfig,
  chartActionInToolbar = false,
  onShowLabTestsLineChart,
}) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);

  const sortOptions = [
    { value: Consts.TEST_DATE, label: t("date") },
    { value: Consts.LAB_TEST_NAME, label: t("laboratory_test") },
  ];

  return (
    <div className="w3-row w3-padding-small drugs-sort-row symptom-sort-row">
      <div className="w3-col s8">
        {labTests?.length > 0 ? (
          <div className="symptom-sort-left-group">
            <label className="drugs-sort-label symptom-sort-label">
              {t("sort_by")}:
            </label>
            <div className="flex-aligned-items symptom-sort-controls">
              <Select
                onChange={(selectedOption) =>
                  handleSortChange(selectedOption?.value)
                }
                value={sortOptions?.find(
                  (option) => option?.value === sortConfig?.key,
                )}
                options={sortOptions}
                placeholder={t("select")}
                className="custom-select meds-sort-select symptom-sort-select"
                classNamePrefix="meds-sort-select"
                isSearchable={false}
              />
              <button
                type="button"
                className="symptom-ui-button symptom-ui-button--icon symptom-ui-button--secondary symptom-sort-order-button"
                onClick={() => handleSortChange(sortConfig?.key)}
                aria-label={t("toggle_sort_direction", { defaultValue: "Change sorting direction" })}
              >
                <FontAwesomeIcon
                  icon={sortConfig?.ascending ? faSortUp : faSortDown}
                  className="drugs-sort-icon symptom-sort-order-icon"
                />
              </button>
            </div>
          </div>
        ) : (
          <div className="w3-container"></div>
        )}
      </div>
      { ( context?.role === Consts.HCP_PRESCRIBER || context?.role === Consts.PATIENT ) &&
        <div className="w3-col s4 w3-right-align symptom-sort-action-col">
          <div className="symptom-toolbar-actions">
            {chartActionInToolbar && labTests?.length > 0 && (
              <button
                type="button"
                className="symptom-ui-button symptom-ui-button--icon symptom-ui-button--secondary"
                onClick={onShowLabTestsLineChart}
                aria-label={t("show_chart", { defaultValue: "Show chart" })}
              >
                <FontAwesomeIcon icon={faChartLine} />
              </button>
            )}
            <button
              type="button"
              onClick={() => setAddLabTest(true)}
              className="symptom-ui-button symptom-ui-button--primary responsive-button"
            >
              <FontAwesomeIcon icon={faPlus} />
              <span className="symptom-ui-button__label">{t("add_new_laboratory_test_data")}</span>
            </button>
          </div>
        </div>
      }
    </div>
  );
}

export default SortAndAddNewTest;